import { ColDef, ICellRendererParams, IHeaderParams } from "ag-grid-community";
import { IconButton } from "@mui/material";
import { FC, useCallback, useState } from "react";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import UnfoldMoreIcon from "@mui/icons-material/UnfoldMore";
import UnfoldLessIcon from "@mui/icons-material/UnfoldLess";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";

const size = 32;

const CellRenderer: FC<ICellRendererParams> = ({ node }) => {
  const handleToggle = useCallback(() => {
    node.setExpanded(!node.expanded);
  }, [node]);

  return (
    <IconButton size="small" onClick={handleToggle}>
      {!node.expanded ? (
        <KeyboardArrowRightIcon fontSize="small" />
      ) : (
        <KeyboardArrowDownIcon fontSize="small" />
      )}
    </IconButton>
  );
};

const HeaderComponent: FC<IHeaderParams> = ({ api }) => {
  const [expanded, setExpanded] = useState(false);

  const toggleExpandAll = useCallback(() => {
    setExpanded((expanded) => {
      api.forEachNode((node) => {
        if (node.master) {
          node.setExpanded(!expanded);
        }
      });

      return !expanded;
    });
  }, [api]);

  return (
    <IconButton
      size="small"
      onClick={toggleExpandAll}
      sx={{ m: `-${size / 2}px` }}
    >
      {!expanded ? (
        <UnfoldMoreIcon fontSize="small" />
      ) : (
        <UnfoldLessIcon fontSize="small" />
      )}
    </IconButton>
  );
};

export const resourceGridExpanderColumnDef: ColDef = {
  colId: "resourceGridExpanderColumnDefColId",
  pinned: "left",
  suppressKeyboardEvent: () => true,
  lockVisible: true,
  cellStyle: { padding: 0 },
  width: size,
  minWidth: size,
  maxWidth: size,
  sortable: false,
  resizable: false,
  lockPinned: true,
  enableRowGroup: false,
  lockPosition: "left",
  suppressMovable: true,
  suppressAutoSize: true,
  suppressSizeToFit: true,
  suppressColumnsToolPanel: true,
  suppressHeaderContextMenu: true,
  suppressHeaderMenuButton: true,
  suppressHeaderFilterButton: true,
  suppressFloatingFilterButton: true,
  headerComponent: HeaderComponent,
  cellRenderer: CellRenderer,
};
